import React from 'react';
import { BookOpenIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
const trustItems = [{
  icon: ZapIcon,
  label: 'Descarga inmediata'
}, {
  icon: BookOpenIcon,
  label: '300+ páginas + 6 bonos'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: ShieldCheckIcon,
  label: '7 días de garantía'
}];
export function PromoBar() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <div className="sticky top-0 z-50 bg-rust text-cream" data-id="element-193" data-mp="3lobovjl06an2">
      
    </div>;
}